import { useQuery } from 'react-query';
import { getCompanyPackage } from 'services/crm-checkout-service';

const useCompanyPackage = () => {
  const { data, isLoading: isCompanyPackageLoading } = useQuery(['currentPackage'], () => getCompanyPackage());

  return { companyPackage: data?.data?.data, companyPachageResponseLevel: data?.data?.level, isCompanyPackageLoading };
};

export default useCompanyPackage;
